export default __webpack_public_path__ + "static/media/img16.d3593a42.svg";